export enum BorrowerLendingLimitTableType {
    GuarantorSummary = 'GuarantorSummary',
    Core = 'Core',
    Bridge = 'Bridge',
    SBA = 'SBA',
    Rental = 'Rental',
}
